import { Box } from '@mui/material'
import { actionData } from '../constants'
import { ActionItem } from './action-item'

import { useStyles } from '../styles'

interface IProps {
  onWebChatbotClick: () => void
}

export const ActionList = ({ onWebChatbotClick }: IProps) => {
  const classes = useStyles()

  const handleTGNavigate = () => {
    window.open('https://t.me/trackgoodai', '_blank', 'noopener,noreferrer')
  }
  return (
    <Box className={classes.actionsContainer}>
      {actionData.map(({ actionText, description, disabled, onClick }, index) => (
        <ActionItem
          key={index}
          actionText={actionText}
          description={description}
          disabled={disabled}
          onClick={
            actionText === 'Web Chatbot'
              ? onWebChatbotClick
              : actionText === 'Telegram Bot'
                ? handleTGNavigate
                : onClick
          }
        />
      ))}
    </Box>
  )
}
